import React from "react";

export const Header: React.FC = () => {
  return (
    <>
      <h4>{"Bem-Vindo ao Recadastramento Faelce!"}</h4>

      <h5>{"Aqui você fará a atualização dos seus dados cadastrais de forma rápida e segura!"}</h5>
    </>
  );
}